import { mapControl } from '@/constants';
import { vuexEventPathGenerator } from '@/utils';
import { getFilteredOrderList, getOrdersWithSearchQuery, getOrdersWithSearchWord, getOrdersWithSelectType, includedWorkerFilter, listControlSortOrderList, sortWorkerList, } from '@/lib/map-control/helper';
import { sortLogic, workerSortLogic, } from '@/constants/listControl';
import { multiSort } from '@/utils/sort';
export const getterType = {
    getterOrderList: 'getterOrderList',
    getterMainOrderList: 'getterMainOrderList',
    getterSelectedWorkerCode: 'getterSelectedWorkerCode',
    getterSelectedWorkerOrderList: 'getterSelectedWorkerOrderList',
    getterGetOrderItem: 'getterGetOrderItem',
    getterGetRelatedWorkerOrderItem: 'getterGetRelatedWorkerOrderItem',
    getterCanceledRatio: 'getterCanceledRatio',
    getterPayCardData: 'getterPayCardData',
    // 라이더
    getterMainWorkerList: 'getterMainWorkerList',
    getterWorkerList: 'getterWorkerList',
    includesSelectedItemList: 'includesSelectedItemList',
    isMaxSelectedItem: 'isMaxSelectedItem',
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const positionDataBuilder = {
    _order({ orderList }, id) {
        const { dropLatitude: lat, dropLongitude: lng } = orderList[id];
        return {
            lat,
            lng,
        };
    },
    _worker({ workerList }, id) {
        const worker = workerList[id];
        if (!worker) {
            return false;
        }
        const { location: { latitude: lat, longitude: lng } } = worker;
        return {
            lat,
            lng,
        };
    },
    _store({ storeList }, id) {
        const { position: [lat, lng,] } = storeList[id];
        return {
            lat,
            lng,
        };
    },
    build(key, state, targetId) {
        try {
            return this[`_${key}`](state, targetId);
        }
        catch (error) {
            // TODO 에러 로그 작업 필요
            return console.log(error);
        }
    },
};
export const listControlGetterType = vuexEventPathGenerator(getterType, 'listControl');
const getter = {
    /**
     * 주문 1차 필터 >> 전체에서 제외할 것들 필터링
     * 리스트는 1차 필터, 2차 필터로 나뉨.
     * 주문 리스트 (공유 주문 숨김 적용)
     * 추가적 필터 지속적으로 적용 예정..
     */
    [getterType.getterOrderList]: ({ orderList }) => {
        const result = {};
        // const {
        //   isHideShareOrder,
        // } = mapVisibilitySetting;
        Object.values(orderList).forEach((order) => {
            // 목록관제는 공유 숨김 기능 아직 없음.
            // 나중에 생길 수도 있으니 주석 처리. 20240607 윤태건
            // 공유주문숨김시 접수상태건 제외.
            // if (
            // order.isShareOrder
            // && isHideShareOrder
            // && order.isAccepted
            // ) {
            // return;
            // }
            // 배차 건의 경우 내 소속 허브 라이더에게 배차되지 않은 공유주문이면 숨기기
            if (order.allocatedWorkerCode
                && order.isShareOrderAndNotMyWorker()) {
                return;
            }
            result[order.orderId] = order;
        });
        return result;
    },
    [getterType.getterSelectedWorkerCode]: ({ selectedWorker }) => selectedWorker?.user?.code,
    /**
     * 2차 필터
     * 선택된 라이더 배차건 목록
     */
    [getterType.getterSelectedWorkerOrderList]: ({ selectedWorkerOrderList, 
    // mapVisibilitySetting,
    searchOrderQuery, selectedWorker, }) => {
        const result = {};
        Object.values(selectedWorkerOrderList).forEach((order) => {
            if (
            // mapVisibilitySetting.isHideShareOrder &&
            order.isShareOrderAndNotMyWorker()) {
                return;
            }
            result[order.orderId] = order;
        });
        // 검색 결과
        const resultSearchQuery = getOrdersWithSearchQuery(result, searchOrderQuery);
        // 라이더 필터 결과 (배달필터 무시 작업으로 인해 필터는 항시 ALL로 고정)
        const resultWorkerFilter = getFilteredOrderList(resultSearchQuery, [
            mapControl.orderStatusGroupList.ALL.code,
        ], (order) => {
            if ((!order.isAccepted && selectedWorker?.user)
                && order.allocatedWorkerCode === selectedWorker.user.code) {
                return true;
            }
            return false;
        });
        // 정렬
        return listControlSortOrderList(resultWorkerFilter);
    },
    /**
     * 2차 필터 >> 해당 영역에서만 제외할 것들 필터
     * 상태 필터 + 연관 주문 제외 리스트
     * @param state
     * @returns
     */
    [getterType.getterMainOrderList]: ({ sortBy, searchWord, selectedOrderFilter, selectedOwnerType, selectedPayType, selectedSearchWordType, selectedOrderAgencyType, }, getters) => {
        // 발주유형, 결제방법 필터
        const resultSelectType = getOrdersWithSelectType(getters.getterOrderList, selectedOwnerType, selectedPayType, selectedOrderAgencyType);
        // 검색어 필터
        const resultSearchWord = getOrdersWithSearchWord(resultSelectType, searchWord, selectedSearchWordType);
        // 주문 필터
        const resultFilter = getFilteredOrderList(resultSearchWord, selectedOrderFilter, () => true);
        let resultSort = [];
        // 정렬
        if (sortBy && sortBy.length > 0) {
            resultSort = multiSort(resultFilter, sortLogic, sortBy);
            // 기본 정렬
        }
        else {
            resultSort = listControlSortOrderList(resultFilter);
        }
        return resultSort;
    },
    // [getterType.getterSelectedOrderCount]: (state) => Object.keys(state.selectedOrderItemsObj).length,
    /**
     * 특정 주문 추출 (전체 or 필터 된 데이터 기준)
     * @param state
     * @returns 주문 데이터
     */
    [getterType.getterGetOrderItem]: (state, getters) => (orderId) => (getters.getterMainOrderList.find((order) => String(order.orderId) === String(orderId))),
    /**
     * 라이더 배차건에서 특정 주문 조회
     * @param {*} state
     * @returns {Object} 주문 데이터
     */
    [getterType.getterGetRelatedWorkerOrderItem]: (state, getters) => (orderId) => (getters.getterSelectedWorkerOrderList.find((order) => String(order.orderId) === String(orderId))),
    /**
     * 취소율
     * 취소건 / 전체건 * 100
     */
    [getterType.getterCanceledRatio]: (state) => {
        const value = (state.orderTotal.CANCELED / state.orderTotal.ALL) * 100;
        if (!value) {
            return 0;
        }
        if (value === 100) {
            return value;
        }
        return value.toFixed(2);
    },
    /**
     * 신용카드 완료건 및 완료율
     */
    [getterType.getterPayCardData]: (state) => {
        const value = (state.cardOrderCount / state.orderTotal.ALL) * 100;
        if (!state.orderTotal.DROP_FINISHED
            || !state.cardOrderCount) {
            return {
                count: 0,
                ratio: 0,
            };
        }
        return {
            count: state.cardOrderCount,
            ratio: value === 100 ? 100 : value.toFixed(2),
        };
    },
    /**
     * 워커 1차 필터
     * @returns
     */
    [getterType.getterWorkerList]: ({ searchWorkerQuery, workerList, selectedWorkerFilter,
    // mapVisibilitySetting,
     }) => {
        // const {
        //   isHideShareWorker,
        // } = mapVisibilitySetting;
        const result = {};
        Object.entries(workerList).forEach(([key, workerData]) => {
            const { user,
            // isShareWorker,
             } = workerData;
            const { name } = user;
            // 공유 라이더 숨김 채크
            // if (isShareWorker && isHideShareWorker) {
            //   return;
            // }
            // 라이더 상태 필터 채크
            if (!includedWorkerFilter(workerData, selectedWorkerFilter)) {
                return;
            }
            // 검색어와 다르면 숨김
            if (!name.toLowerCase().includes(searchWorkerQuery.toLowerCase())) {
                return;
            }
            result[key] = workerData;
        });
        return result;
    },
    /**
     * 워커 2차 필터
     * 워커 메인 패널 리스트
     * TODO 개선 필요..
     * @returns
     */
    [getterType.getterMainWorkerList]: ({ workerSortBy, }, { getterWorkerList, }) => {
        const result = {};
        // 1. 제거
        Object.entries(getterWorkerList).forEach(([key, workerData]) => {
            // 가중치가 있는 것 제외 (연관 라이더에 해당 됨)
            if (workerData.relatedWeight && workerData.relatedWeight > 0) {
                return;
            }
            result[key] = workerData;
        });
        let resultSort = [];
        // 2. 정렬
        if (workerSortBy && workerSortBy.length > 0) {
            resultSort = multiSort(result, workerSortLogic, workerSortBy);
            // 기본 정렬
        }
        else {
            resultSort = sortWorkerList(result);
        }
        return resultSort;
    },
    /**
     * 선태된 항목에 포함되는지 여부
     */
    [getterType.includesSelectedItemList]: (state) => (orderId) => (Object.keys(state.selectedOrderItemsObj).some((key) => (String(key) === String(orderId)))),
    /**
     * 선택할 수 있는 최대치 여부
     * @returns Boolean
     */
    [getterType.isMaxSelectedItem]: (state) => {
        // 배달 요청 선택 최대치
        const LIMIT = mapControl.SELECT_ORDER_MAX_COUNT;
        return Object.keys(state.selectedOrderItemsObj).length >= LIMIT;
    },
};
export default getter;
